<template>
    <div>
        <div class="row">
            <div v-for="item in list" :key="item.id" class="col-sm-6 col-md-4 col-lg-3 row-flex">
                <cardWrapper class="text-left">
                    <img  v-if="type==2" class="card-img-top img-fluid mb-1" style="height:auto; width: auto;" :src="item.preview">  
                    <div class="acad-body">
                        <div v-if="item.date">{{item.date}}</div>
                        
                        <div class="acad-anonce">
                            <div class="mb-1"><strong>{{item.name}}</strong></div>
                            <div>{{item.anonce}}</div>
                        
                    </div>
                    <a class="btn mt-2 btn-outline-success acad-button" @click="unit_id = item.id">{{$t('message.details')}}</a>    
                    </div>
                </cardWrapper>
            </div>     
        </div>
        <academyForm @clear="clear" :id = "unit_id"></academyForm>
    </div>
    

</template>

<script>
import cardWrapper from '@/components/cardWrapper'; 
import academyForm from '@/forms/academy_form';
import globalSettings from '@/config.js'
import axios from '@/axios'
export default {
  name: 'academy',
  props:{
            type: {
                type: Number,
            }
        },
  data () {
        return {
            unit_id:null,
            list:[]
        }
  },
  methods:{
       clear:  function () {
            this.unit_id = null
        },
      
      setList:  function () {
            axios.get(globalSettings.api_url + 'academy/'+this.type+'/list?lang='+this.$i18n.locale)
            .then(response => {
                this.list = response.data
            }) 
        },
  },
  components:{
    cardWrapper,academyForm
  },
  mounted() {
       this.setList()
  },
}

</script>
<style>
    ul.webin_subs{
        position: relative;
        display: inline-block;
            list-style-type: none;
            margin: 20px auto;
    }    
    ul.webin_subs li{
        position: relative;
        float: left;
        padding: 10px;
    }
    a.tn-atom img{
          width:  50px;
          height: auto;
    }
    .acad-body{
        position: relative;
          
            padding-bottom: 50px;
          
    }
    .acad-anonce{
        height: 250px; 
        overflow: hidden;
        background: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0)), to(#000));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .acad-button{
         position: absolute;
         bottom:0;
         left: 0;
    }
    .row-flex, .row-flex > div[class*='col-'] {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex: 1 1 auto;
    }
</style>


	